define("CCATrustedBrands.CCATrustedBrands.CCATrustedBrands", [
    "CCATrustedBrands.CCATrustedBrands.CCATrustedBrands.View",
], function (CCATrustedBrandsView) {
    "use strict";

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent("Layout");

            if (layout) {
                layout.addChildView("CCAW.TrustedBrands.View", function () {
                    return new CCATrustedBrandsView({ container: container });
                });
            }
        },
    };
});
